import { Button, Col, DatePicker, Form, Input, Row } from 'antd';
import { useCallback, useContext, useEffect } from 'react';
import dayjs from 'dayjs';
import LabeledInput from '../ui/LabeledInput';
import CTX from '../../lib/AssignmentsContext';
const DetailsForm = ({
  assignmentIndex = 0,
  onCancel
}) => {
  const {
    data: {
      klass,
      assignments
    }
  } = useContext(CTX);
  const assignment = assignments[assignmentIndex].data;
  const [form] = Form.useForm();
  useEffect(() => {
    form.validateFields();
  });
  const errorFor = field => form.isFieldTouched(field) && form.getFieldError(field)[0] || '';
  const statusFor = field => errorFor(field) ? 'error' : 'success';
  const defaultVars = {
    startDate: assignment.startDate,
    endDate: assignment.endDate,
    label: assignment.label,
    ...Object.fromEntries(assignment.instructions.map((ins, i) => [`directions-${i}`, ins]) || [])
  };
  const onFinish = vars => {
    assignment.instructions = assignment.tasks.map((_, i) => vars[`directions-${i}`]);
    assignment.label = vars.label;
    assignment.startDate = vars.startDate;
    assignment.endDate = vars.endDate;
  };
  const disabledDates = d => d.isBefore(klass?.startDate) || d.isAfter(klass?.endDate);
  const onValuesChange = useCallback(({
    startDate,
    endDate
  }) => {
    const limitToKlass = d => d.isBefore(klass?.startDate) ? dayjs(klass.startDate) : d.isBefore(klass?.endDate) ? d : dayjs(klass.endDate);
    if (startDate && !form.isFieldTouched('endDate')) {
      form.setFields([{
        name: 'endDate',
        touched: false,
        value: limitToKlass(dayjs(startDate).add(7, 'days'))
      }]);
      form.validateFields(['endDate']);
    } else if (endDate && !form.isFieldTouched('startDate')) {
      form.setFields([{
        name: 'startDate',
        touched: false,
        value: limitToKlass(dayjs(endDate).subtract(7, 'days'))
      }]);
      form.validateFields(['startDate']);
    }
  }, [form, klass]);
  return <Form form={form} initialValues={defaultVars} onFinish={onFinish} onValuesChange={onValuesChange} data-sentry-element="Form" data-sentry-component="DetailsForm" data-sentry-source-file="DetailsForm.jsx">
      <Form.Item noStyle shouldUpdate data-sentry-element="unknown" data-sentry-source-file="DetailsForm.jsx">
      {() => <>
          <LabeledInput label="Assignment Label">
            <Form.Item name="label" rules={[{
            required: true
          }]} validateStatus={statusFor('label')} help={errorFor('label')}>
              <Input placeholder={name} />
            </Form.Item>
          </LabeledInput>
          <div style={{
          display: assignment.tasks.length > 1 ? 'none' : null
        }}>
          {assignment.tasks.map((task, index) => <LabeledInput label={`Student Directions - ${task.name}`} key={`task-${index}`}>
                <Form.Item name={`directions-${index}`}>
                  <Input placeholder="Add instructions for students" />
                </Form.Item>
              </LabeledInput>)}
          </div>
          <LabeledInput label="Assignment Active Dates">
            <Form.Item name="startDate" rules={[{
            required: true,
            message: 'Start Date is required.'
          }]} validateStatus={statusFor('startDate')} help={errorFor('startDate')}>
              <DatePicker placeholder="Start Date" format="MM/DD/YYYY" disabledDate={disabledDates} />
            </Form.Item>
            {' '}
            <Form.Item name="endDate" validateFirst rules={[{
            required: true,
            message: 'End Date is required.'
          }, {
            validator: async (r, v) => {
              const startDate = form.getFieldValue('startDate');
              if (startDate && v && v.isBefore(startDate, 'day')) {
                throw new Error();
              }
            },
            message: "End Date can't be before Start Date"
          }, {
            validator: async (r, v) => {
              if (v && v.isBefore(new Date(), 'day')) {
                throw new Error();
              }
            },
            message: "End Date can't be before today"
          }]} validateStatus={statusFor('endDate')} help={errorFor('endDate')} dependencies={['startDate']}>
              <DatePicker placeholder="End Date" format="MM/DD/YYYY" disabledDate={d => disabledDates(d) || d.isBefore(form.getFieldValue('startDate'))} />
            </Form.Item>
          </LabeledInput>
          <Row type="flex" justify="space-between">
            {onCancel && <Col>
                  <Button type="default" onClick={onCancel}>
                    Back
                  </Button>
                </Col>}
            <Col>
              <Button type="primary" htmlType="submit" disabled={form.getFieldsError().filter(({
              errors
            }) => errors.length).length > 0}>
                Assign
              </Button>
            </Col>
          </Row>
        </>}
      </Form.Item>
    </Form>;
};
export default DetailsForm;